import { INSUFFICIENT_CREDITS_CODE } from "@shared/schemas/enums";

export function isInsufficientCreditsError(errorOrResponse: unknown): boolean {
  return (
    errorOrResponse != null &&
    typeof errorOrResponse === "object" &&
    "code" in errorOrResponse &&
    (errorOrResponse as { code?: string }).code === INSUFFICIENT_CREDITS_CODE
  );
}
